/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc)
 */
 
import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { RecipeInstructionBase } from 'shared/dbo/RecipeInstruction';

export interface RecipeInstructionIndexedDb {
	id: string;
	recipeId: string;
	stepNumber: number;
	description: string;
	timeAmount?: number;
	timeType?: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isRecipeInstructionIndexedDb = (obj: unknown): obj is RecipeInstructionIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ recipeId: unknown }>(obj, 'recipeId') || !(typeof obj.recipeId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ stepNumber: unknown }>(obj, 'stepNumber') || !(typeof obj.stepNumber === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ description: unknown }>(obj, 'description') || !(typeof obj.description === 'string')) {
		return false;
	}
	if (hasPropOfType<{ timeAmount: unknown }>(obj, 'timeAmount') && !(typeof obj.timeAmount === 'number')) {
		return false;
	}
	if (hasPropOfType<{ timeType: unknown }>(obj, 'timeType') && !(typeof obj.timeType === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: RecipeInstructionBase): RecipeInstructionIndexedDb => ({
	id: obj.id.toString(),
	recipeId: obj.recipeId.toString(),
	stepNumber: Number(obj.stepNumber),
	description: obj.description,
	timeAmount: typeof obj.timeAmount === 'undefined' ? obj.timeAmount : Number(obj.timeAmount),
	timeType: typeof obj.timeType === 'undefined' ? obj.timeType : obj.timeType,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: RecipeInstructionIndexedDb): RecipeInstructionBase => ({
	id: UUID.fromString(obj.id),
	recipeId: UUID.fromString(obj.recipeId),
	stepNumber: BigInt(obj.stepNumber),
	description: obj.description,
	timeAmount: typeof obj.timeAmount === 'undefined' ? obj.timeAmount : BigInt(obj.timeAmount),
	timeType: obj.timeType,
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdRecipeInstruction: LocalDatabaseTableDefinition<RecipeInstructionBase, RecipeInstructionIndexedDb> = {
	tableName: 'recipeInstructions',
	indexColumns: ['recipeId'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
